/* eslint-disable @typescript-eslint/no-namespace */
import { Box } from '@mui/material';
import React from 'react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'hb-global-navigator': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

export function GlobalNav(): React.JSX.Element {
  return (
    <Box minHeight={64} bgcolor='#2f3b4d' data-testid='hb-navbar'>
      <hb-global-navigator app-origin={window.location.origin} />
    </Box>
  );
}
